import React, { useState, useEffect } from 'react';
import { Dropzone, Browser } from '@atlaskit/media-picker';
import { Clipboard } from '@atlassian/jira-clipboard/src/ui/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { AttachmentsUploadProps } from './types.tsx';

const AttachmentsUpload = (props: AttachmentsUploadProps) => {
	const [isBrowserOpen, setIsBrowserOpen] = useState<boolean>(false);
	const {
		dropzoneContainer,
		onUploadStart,
		onUploadError,
		mediaClientConfig,
		uploadConfig,
		onUploadEnd,
		children: renderPropFn,
	} = props;

	// Force remount of media picker components when mediaClientConfig changes
	// This is needed because Browser/Dropzone/Clipboard components don't update their mediaClient on re-render
	// Only enable this behavior when token refresh feature gate is enabled
	const [mediaConfigRefreshCount, setMediaConfigRefreshCount] = useState(0);
	useEffect(() => {
		if (fg('gic-attachment-media-token-refresh')) {
			setMediaConfigRefreshCount((prev) => prev + 1);
		}
	}, [mediaClientConfig]);

	const dropzoneConfig = {
		...uploadConfig,
	};

	const browserConfig = {
		...uploadConfig,
		multiple: true,
	};

	const clipboardConfig = {
		...uploadConfig,
	};

	if (dropzoneContainer) {
		dropzoneConfig.container = dropzoneContainer;
	}

	return (
		<>
			<Browser
				isOpen={isBrowserOpen}
				config={browserConfig}
				mediaClientConfig={mediaClientConfig}
				onUploadsStart={onUploadStart}
				onError={onUploadError}
				onEnd={onUploadEnd}
				onClose={() => setIsBrowserOpen(false)}
				key={
					fg('gic-attachment-media-token-refresh')
						? `browser-${mediaConfigRefreshCount}`
						: 'browser'
				}
			/>
			<Dropzone
				mediaClientConfig={mediaClientConfig}
				config={dropzoneConfig}
				onUploadsStart={onUploadStart}
				onEnd={onUploadEnd}
				key={
					fg('gic-attachment-media-token-refresh')
						? `dropzone-${mediaConfigRefreshCount}`
						: 'dropzone'
				}
			/>
			<Clipboard
				mediaClientConfig={mediaClientConfig}
				config={clipboardConfig}
				onUploadsStart={onUploadStart}
				onEnd={onUploadEnd}
				isolated={false}
				key={
					fg('gic-attachment-media-token-refresh')
						? `clipboard-${mediaConfigRefreshCount}`
						: 'clipboard'
				}
			/>
			{renderPropFn({ setIsBrowserOpen })}
		</>
	);
};

export default AttachmentsUpload;
